import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

export function Buttons(): JSX.Element {
	return (
		<Button type="submit" variant="primary" data-qa="report-abuse-submit-button">
			<Translate value="fe.components.petition_report_abuse.form_submit" />
		</Button>
	);
}
